import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  Typography,
  TableRow,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Select,
  ListItem,
  ListItemButton,
} from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { useMessage } from "../../context/message-context";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { FullPageSpinner } from "../lib";
import openFile from "../shared/functions/download";
import Formular from "../Formular/Formular";
import MandatoryDocForm from "./MandatoryDocForm";
function MandatoryDocConfirm(props) {
  const { t } = useTranslation();
  let { pflichtdok } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [documents, setDocuments] = useState(null);
  const [fileName, setFileName] = useState("");
  const { accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modus, setModus] = useState("");
  const [formular, setFormular] = useState("");
  const [felderError, setFelderError] = useState([]);
  const [felder, setFelder] = useState([]);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [antworten, setAntworten] = useState({});
  const { hideMessage, showErrorMessage } = useMessage();
  const vorschau = location?.state?.vorschau ? location?.state.vorschau : "";
  const setzeAntworten = (key, value) => {
    let values = Object.assign(antworten);
    values[key] = value;
    console.log(values);
    setAntworten(values);
    forceUpdate();
  };
  const setzeAntwortenDropbox = (key, value) => {
    let values = Object.assign(antworten);
    if (value === true) {
      values[key] = "Ja";
    } else {
      values[key] = "Nein";
    }
    console.log(values);
    setAntworten(values);
    forceUpdate();
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const open = () => {
    setShowModal(true);
    downloadFile();
  };
  const schreibeDaten = () => {
    if (vorschau !== "") {
      navigate(-1);
      return;
    }
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "SPEICHERN",
      hdsakey: pflichtdok,
      antworten: antworten,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, schreibeCb);
  };
  const schreibeCb = (response) => {
    if (response.status === 200) {
      hideMessage();
      navigate(-1);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const ladeDocuments = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "AUSWAHL",
      hdsakey: pflichtdok,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, documentCb);
  };
  // useEffect(() => {
  //   if (fileName !== '') {
  //     // open();
  //   }
  //   // eslint-disable-next-line
  // }, [documents, fileName]);
  useEffect(() => {
    ladeDocuments();
    // eslint-disable-next-line
  }, []);
  const downloadFile = () => {
    console.log("file with key: ", pflichtdok);
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "DATEI_LADEN",
      hdsakey: pflichtdok,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var contentFile = response.data;
        const mimeType = response.headers["Content-Type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(
          "Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."
        );
      });
  };
  const documentCb = (response) => {
    if (response.status === 200) {
      setModus(response.data.fragenModus);
      if (response.data.fragenModus === "FORMULAR") {
        setFormular(Object.keys(response.data.felder)[0]);
        setFelder(response.data.felder);
        console.log("si");
      }
      if (response.data.document) {
        setDocuments(response.data.document);
        setFileName(response.data.filename);
      } else {
        setDocuments([]);
        setFileName("");
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  if (isLoading) {
    return <LoadingComponent />;
  }
  if ((!documents )) {
    return (
      <Typography color="primary" variant="h5">
        {t("Pflichtdokument konnte nicht gefunden werden")}
      </Typography>
    );
  }

  const dataRequest =
    documents.length > 0 ? (
      documents.map((element) => {
        return (
          <Fragment>
            {element.art === "E" ? (
              <Box pt={3}>
                <Typography align="left" variant="body2">
                  {element.bez}
                </Typography>
                <TextField
                  variant="outlined"
                  id={element.bez}
                  fullWidth
                  margin="normal"
                  onChange={(event) =>
                    setzeAntworten(element.key, event.target.value)
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
            ) : element.art === "C" ? (
              <Fragment>
                <FormControlLabel
                  fullWidth
                  variant="outlined"
                  control={
                    <Checkbox
                      onChange={(event) =>
                        setzeAntwortenDropbox(element.key, event.target.checked)
                      }
                      color="primary"
                      inputProps={{ "aria-label": "secondary checkbox" }}
                    />
                  }
                  label={element.bez}
                />
              </Fragment>
            ) : (
              element.art === "A" && (
                <Box pt={3}>
                  <Typography align="left" variant="body2">
                    {element.bez}
                  </Typography>
                  <Select
                    variant="outlined"
                    id={element.bez}
                    value={antworten[element.key]}
                    onChange={(event) =>
                      setzeAntworten(element.key, event.target.value)
                    }
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    {element.drop.map((antwort) => {
                      return (
                        <ListItemButton value={antwort.key}>
                          {antwort.wert}
                        </ListItemButton>
                      );
                    })}
                  </Select>
                </Box>
              )
            )}
          </Fragment>
        );
      })
    ) : (
      <TableRow>
        <Typography variant="body1">
          {t("Es wurden keine offenen Pflichtdokumente gefunden")}
        </Typography>
      </TableRow>
    );
  return (
    <Page>
      <Layout>
        <Box p={2}>
          <Button
            onClick={() => open()}
            variant="contained"
            color="primary"
            fullWidth
          >
            {t("Dokument öffnen")}
          </Button>
          {modus === "TEXT" ? (
            <>
              {" "}
              {dataRequest}
              <Box pt={2}>
                <Button
                  onClick={() => schreibeDaten()}
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  {" "}
                  {vorschau !== ""
                    ? t("Vorschau beenden")
                    : t("Bestätigung abschicken")}{" "}
                </Button>
              </Box>
            </>
          ) : (
            <>    
              <MandatoryDocForm
                formular={formular}
                liste={felder[formular][formular]?.inhalt.split(";")}
                felder={felder}
                accessToken={accessToken} client={client}
                pflichtdok={pflichtdok}
              />
              {/* <Formular
                key={"1"}
                bez={"test"}
                formular={formular}
                liste={felder[formular][formular]?.inhalt.split(";")}
                felder={felder}
                stammfelder={formular}
                // hper={hper}
                // ChangeFelder={ChangeFelder}
                // uebergaben={uebergaben}
                felderError={[]}
                // lock={status === "G" || status === "X" || status === "S"}
                // ChangeFiles={ChangeFiles}
                // files={files}
                // DateiLaden={DateiLaden}
                // bemerkung={bemerkung}
                // ZSpeichern={Refresh}
                // client={client}
                // accessToken={accessToken}
                // program={"FORMUL"}
              /> */}
            </>
          )}
        </Box>
      </Layout>
      {showModal && <FullPageSpinner />}
    </Page>
  );
}
export default MandatoryDocConfirm;
